export default "__VITE_ASSET__B3yMnW$k__"